import { render, staticRenderFns } from "./select-branch.vue?vue&type=template&id=1ece8920&"
import script from "./select-branch.vue?vue&type=script&lang=js&"
export * from "./select-branch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports